import imgDespegar from "assets/apps/despegar.png";
import imgBooking from "assets/apps/booking.png";
import imgExpedia from "assets/apps/expedia.png";
import imgHouse from "assets/apps/house.png";

const TYPES = [
  { id: "11", name: "registro_civil" },
  { id: "12", name: "tarjeta_identidad" },
  { id: "13", name: "cedula_ciudadania" },
  { id: "21", name: "tarjeta_extranjeria" },
  { id: "22", name: "cedula_extranjeria" },
  { id: "31", name: "nit" },
  { id: "41", name: "pasaporte" },
  { id: "42", name: "tipo_documento_extranjero" },
  { id: "47", name: "pep" },
  { id: "50", name: "nit_otro_pais" },
  { id: "91", name: "nuip" },
];

const ICON_CHANNEL = {
  house: imgHouse,
  corporativo: imgHouse,
  booking: imgBooking,
  despegar: imgDespegar,
  expedia: imgExpedia,
  directo: imgHouse,
  web: imgHouse,
};

export { TYPES, ICON_CHANNEL };
